import { render, staticRenderFns } from "./InternalInvoice.vue?vue&type=template&id=4350b54c&scoped=true&"
import script from "./InternalInvoice.vue?vue&type=script&lang=js&"
export * from "./InternalInvoice.vue?vue&type=script&lang=js&"
import style0 from "./InternalInvoice.vue?vue&type=style&index=0&id=4350b54c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4350b54c",
  null
  
)

export default component.exports